import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import '../../styles/quantity-selector.css';

const QuantitySelector = ({ 
  quantity, 
  onQuantityChange, 
  stock, 
  productName,
  categoryName,
  pricePerItem 
}) => {
  
  // Get preset quantities based on product category
  const getPresetQuantities = () => {
    if (categoryName === 'Chairs') {
      return [1, 5, 10, 15, 20];
    } else if (categoryName === 'Tables') {
      return [1, 2, 4, 6];
    }
    return [1];
  };
  
  const presetQuantities = getPresetQuantities();
  
  const handleQuantityChange = (newQuantity) => {
    if (newQuantity >= 1 && newQuantity <= stock) {
      onQuantityChange(newQuantity);
    }
  };
  
  const handlePresetClick = (presetQuantity) => {
    if (presetQuantity <= stock) {
      onQuantityChange(presetQuantity);
    }
  };
  
  const formatPrice = (price) => {
    return typeof price === 'number' ? price.toFixed(2) : parseFloat(price.toString().replace(/[^0-9.]/g, '')).toFixed(2);
  };
  
  const totalPrice = quantity * parseFloat(formatPrice(pricePerItem));

  return (
    <div className="quantity-selector">
      <div className="quantity-header">
        <h4>Quantity</h4>
        <span className="stock-info">{stock} available in Angola</span>
      </div>
      
      {/* Manual Quantity Controls */}
      <div className="quantity-controls">
        <button 
          type="button"
          onClick={() => handleQuantityChange(quantity - 1)}
          className="quantity-btn"
          disabled={quantity <= 1}
          aria-label="Decrease quantity"
        >
          <FontAwesomeIcon icon={faMinus} />
        </button>
        
        <input
          type="number"
          value={quantity}
          onChange={(e) => handleQuantityChange(parseInt(e.target.value) || 1)}
          className="quantity-input"
          min="1"
          max={stock}
        />
        
        <button 
          type="button"
          onClick={() => handleQuantityChange(quantity + 1)}
          className="quantity-btn"
          disabled={quantity >= stock}
          aria-label="Increase quantity"
        >
          <FontAwesomeIcon icon={faPlus} />
        </button>
      </div>
      
      {/* Preset Quantity Buttons */}
      {presetQuantities.length > 1 && (
        <div className="preset-quantities">
          <span className="preset-label">Quick select:</span>
          <div className="preset-buttons">
            {presetQuantities.map((preset) => (
              <button
                key={preset}
                type="button"
                onClick={() => handlePresetClick(preset)}
                className={`preset-btn ${quantity === preset ? 'active' : ''} ${preset > stock ? 'disabled' : ''}`}
                disabled={preset > stock}
              >
                {preset}
              </button>
            ))}
          </div>
        </div>
      )}
      
      {/* Price Calculation */}
      <div className="quantity-pricing">
        <div className="price-breakdown">
          ${formatPrice(pricePerItem)} × {quantity} {categoryName.toLowerCase().slice(0, -1)}{quantity !== 1 ? 's' : ''}
        </div>
        <div className="total-price">
          Total: <strong>${totalPrice.toFixed(2)}</strong>
        </div>
      </div>
      
      {/* Stock Warning */}
      {quantity > stock * 0.8 && (
        <div className="stock-warning">
          ⚠️ Limited availability - only {stock} in stock
        </div>
      )}
    </div>
  );
};

export default QuantitySelector;